import logger from 'redux-logger';
import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import rootReducer from './reducers';
import checkoutDecision from './middleware/checkoutDecision';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default () => {
  /* eslint-disable no-underscore-dangle */
  const store = createStore(persistedReducer, applyMiddleware(checkoutDecision, logger));
  /* eslint-enable */
  const persistor = persistStore(store);
  return { store, persistor };
};
